import { bc } from 'components/UI/colors';
import { CurrencyOpts, fMoney } from 'components/utils/formatters';
import React from 'react';

interface Props {
  value?: number | null;
  colorizeNegative?: boolean;
  opts?: Partial<CurrencyOpts>;
}

/**
 * @deprecated Use Money from "src/utils/money.ts" instead.
 */
const Currency: React.FC<Props> = ({ value, colorizeNegative, opts }) =>
  colorizeNegative ? (
    <div style={{ color: value && value < 0 ? bc.errorDark : 'initial' }}>{fMoney(value, opts)}</div>
  ) : (
    <>{fMoney(value, opts)}</>
  );

export default Currency;
